/* eslint-disable */
export default {
  api_url: 'http://api-tp.cailiao.com/index.php/mapi/',
  base_url: 'http://www.lianlvyun.com/openapi/Clwcyf?fun='
}



// WEBPACK FOOTER //
// ./src/api/config.js